var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { AonDialog } from "../../components/core/AonDialog";
import { UuiFlexlayout, UuiLogo } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { useAppInfoStore } from "../../store";
import "./clientStaffDailog.scss";
import { AonInput } from "../../components/core/AonInput";
import { AonMultiSelect } from "../../components/core/AonMultiSelect";
import { getAMBestVal, getSandPVal } from "../../api/common";
import { AonSelect } from "../../components/core/AonSingleSelect";
import { observer } from "mobx-react";
export var AdvanceSearchDailog = observer(function (props) {
    var DailogBody = function () {
        var appInfo = useAppInfoStore();
        var _a = useState(false), apiLoading = _a[0], setApiLoading = _a[1];
        var _b = useState({
            companyName: "",
            groupName: "",
            formerName: "",
            countries: [],
            regions: [],
            states: [],
            marketTypeId: [],
            phs: "",
            capacity: "",
            amBest_a: "",
            amBest_b: "",
            sAndp_a: "",
            sAndp_b: "",
        }), form = _b[0], setForm = _b[1];
        var _c = useState([]), availableCountry = _c[0], setAvailableCountry = _c[1];
        var _d = useState((appInfo === null || appInfo === void 0 ? void 0 : appInfo.marketType) ? __spreadArray([], appInfo.marketType, true) : []), allMarketType = _d[0], setAllMarketType = _d[1];
        var _e = useState({
            amBest: [],
            sp: [],
        }), allOptions = _e[0], setAllOptions = _e[1];
        var _f = useState([]), validationError = _f[0], setValidationError = _f[1];
        var saveForm = function (name, value, event) {
            var _a;
            if (event === void 0) { event = ""; }
            if (value || ((value === null || value === void 0 ? void 0 : value.length) && value.length >= 0)) {
                if (name === "regions" && typeof value === "object") {
                    setAvailableCountry((_a = appInfo.country) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return value.includes(item.regionId.toString()); }));
                    if (value[0] === "7" && form.countries[0] === "203") {
                        return;
                    }
                    setForm(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a.countries = [], _a.states = [], _a)));
                    });
                    return;
                }
                else if (typeof value === "object" && name === "states") {
                    if (value.length > 0) {
                        setForm(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a.countries = ["203"], _a.regions = ["7"], _a)));
                        });
                    }
                    // else if (value.length === 0) {
                    //setForm((prev) => { return ({ ...prev, [name]: value, countries: [], regions: [] }) });
                    // return;    
                    // }
                    else {
                        setForm(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a.countries = [], _a.regions = [], _a)));
                        });
                    }
                    return;
                }
                else if (typeof value === "object" && name === "countries") {
                    if (value[0] === "203" && form.regions[0] === "7" && value.length === 1) { //added 7 for countries
                        // setForm((prev) => { return ({ ...prev, [name]: value }) });
                        return;
                    }
                    else if (value.length > 1) {
                        //clear state
                        setForm(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a.states = [], _a)));
                        });
                        return;
                    }
                    else {
                        setForm(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
                        });
                        return;
                    }
                }
                else {
                    setForm(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
                    });
                }
            }
        };
        useEffect(function () {
            fetchData();
        }, []);
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var amBestVal, sAndPVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAMBestVal()];
                    case 1:
                        amBestVal = _a.sent();
                        return [4 /*yield*/, getSandPVal()];
                    case 2:
                        sAndPVal = _a.sent();
                        setAllOptions({ amBest: amBestVal.data, sp: sAndPVal.data });
                        return [2 /*return*/];
                }
            });
        }); };
        var getCountriesCode = function () {
            var _a, _b;
            if (form.countries.length) {
                var allSelectedCountry = (_a = appInfo.country) === null || _a === void 0 ? void 0 : _a.filter(function (country) { var _a; return form.countries.includes((_a = country.countryId) === null || _a === void 0 ? void 0 : _a.toString()); });
                return allSelectedCountry === null || allSelectedCountry === void 0 ? void 0 : allSelectedCountry.map(function (country) { return country.countryCode; }).join(",");
            }
            else if (form.regions.length === 0) {
                return undefined;
            }
            else {
                return (_b = appInfo.country) === null || _b === void 0 ? void 0 : _b.filter(function (con) { return form.regions.includes(con.regionId.toString()); }).map(function (con) { return con.countryCode; }).join(",");
            }
        };
        var getStateCode = function () {
            var _a, _b;
            if (form.states.length) {
                var selectedStates = (_a = appInfo.states) === null || _a === void 0 ? void 0 : _a.filter(function (sta) { return form.states.includes(sta.stateId.toString()); });
                return (_b = selectedStates === null || selectedStates === void 0 ? void 0 : selectedStates.map(function (states) { return states.stateCode; })) === null || _b === void 0 ? void 0 : _b.join(",");
            }
            else
                return undefined;
        };
        var getMarketTypeIds = function () {
            var allIds = "";
            if (form.marketTypeId) {
                form.marketTypeId.forEach(function (id) {
                    var MarketTypeData = allMarketType.find(function (data) { return data.marketTypeId.toString() === id; });
                    var allData = allMarketType.filter(function (data) { return data.marketTypeCategoryId === MarketTypeData.marketTypeCategoryId; });
                    if (allIds) {
                        allIds = allIds + "," + allData.map(function (data) { return data.marketTypeId; }).join(",");
                    }
                    else {
                        allIds = allData.map(function (data) { return data.marketTypeId; }).join(",");
                    }
                });
            }
            return allIds;
        };
        var onClickSubmit = function () {
            var errors = [];
            if ((form.amBest_a && !form.amBest_b) || (!form.amBest_a && form.amBest_b)) {
                errors.push("Provide both from and through AM Best Rating");
            }
            if ((form.sAndp_a && !form.sAndp_b) || (!form.sAndp_a && form.sAndp_b)) {
                errors.push("Provide both from and through S&P Rating");
            }
            if (errors.length > 0) {
                setValidationError(errors);
                return;
            }
            var advancePayload = {
                name: form.companyName ? form.companyName : undefined,
                groupName: form.groupName ? form.groupName : undefined,
                formerName: form.formerName ? form.formerName : undefined,
                countryCd: getCountriesCode(),
                state: getStateCode(),
                marketTypeId: form.marketTypeId ? getMarketTypeIds() : undefined,
                fromFinancialValue: form.phs ? form.phs : undefined,
                thruFinancialValue: form.capacity ? form.capacity : undefined,
                fromAmBestRating: form.amBest_a ? form.amBest_a : undefined,
                thruAmBestRating: form.amBest_b ? form.amBest_b : undefined,
                fromSandPRating: form.sAndp_a ? form.sAndp_a : undefined,
                thruSandPRating: form.sAndp_b ? form.sAndp_b : undefined,
            };
            props.handleAdvanceSearch(advancePayload);
            props.onClickClose();
        };
        //to filter the market ID
        var filterUnique = function (data) {
            var existing = [];
            return data.filter(function (item) {
                if (existing.includes(item.marketTypeCategoryDesc)) {
                    return false;
                }
                else {
                    existing.push(item.marketTypeCategoryDesc);
                    return true;
                }
            });
        };
        var onResetForm = function () {
            setForm({
                companyName: "",
                groupName: "",
                formerName: "",
                countries: [],
                regions: [],
                states: [],
                marketTypeId: [],
                phs: "",
                capacity: "",
                amBest_a: "",
                amBest_b: "",
                sAndp_a: "",
                sAndp_b: "",
            });
        };
        var renderContry = (availableCountry === null || availableCountry === void 0 ? void 0 : availableCountry.length) ? availableCountry : appInfo.country;
        var isUsPresent = !!(renderContry === null || renderContry === void 0 ? void 0 : renderContry.find(function (item) { return item.countryId.toString() === "203"; }));
        var isStatesEnable = form.countries.length ? form.countries.length === 1 && form.countries.includes("203") : isUsPresent;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(UuiFlexlayout, { style: { marginBottom: "10px" }, direction: 'row', gap: 'xs' },
                    React.createElement(AonInput, { label: "Company Name", "aria-label": "Outlined", disabled: apiLoading, onTextChange: function (event) { return saveForm("companyName", event.target.value); }, value: form.companyName, type: "text" }),
                    React.createElement(AonInput, { label: "Group Name", "aria-label": "Outlined", disabled: apiLoading, onTextChange: function (event) { return saveForm("groupName", event.target.value); }, value: form.groupName, type: "text" }),
                    React.createElement(AonInput, { label: "Former Name", "aria-label": "Outlined", disabled: apiLoading, onTextChange: function (event) { return saveForm("formerName", event.target.value); }, value: form.formerName, type: "text" })),
                React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                    React.createElement(AonMultiSelect, { label: "Region", state: __spreadArray([], appInfo.regions ? appInfo.regions.map(function (item) {
                            return ({ label: item.name, value: item.id.toString() });
                        }) : [], true), handelChecked: function (event) { return saveForm("regions", event.detail, event); }, selectedList: form.regions }),
                    React.createElement(AonMultiSelect, { enableSearch: true, label: "Country", state: __spreadArray([], renderContry ? renderContry.map(function (item) {
                            return ({ label: item.description, value: item.countryId.toString() });
                        }) : [], true), handelChecked: function (event) { return saveForm("countries", event.detail, event); }, selectedList: form.countries }),
                    React.createElement(AonMultiSelect, { enableSearch: true, disabled: !isStatesEnable, label: "State", state: __spreadArray([], appInfo.states ? appInfo.states.map(function (item) {
                            return ({ label: item.description, value: item.stateId.toString() });
                        }) : [], true), handelChecked: function (event) { return saveForm("states", event.detail, event); }, selectedList: form.states })),
                React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                    React.createElement(AonMultiSelect, { label: "Market Type", state: allMarketType ?
                            filterUnique(allMarketType).map(function (item) {
                                return ({ label: item.marketTypeCategoryDesc, value: item.marketTypeId.toString() });
                            }) : [], handelChecked: function (event) { saveForm("marketTypeId", event.detail); }, selectedList: form.marketTypeId }),
                    React.createElement("div", null,
                        React.createElement("div", { style: { paddingBottom: "5px" } }, "PHS/ASHF/C&S/Capacity (USDmn)"),
                        React.createElement(UuiFlexlayout, { direction: "row", gap: 'md' },
                            React.createElement(AonInput, { "aria-label": "Outlined", disabled: apiLoading, onTextChange: function (event) { return saveForm("phs", event.target.value); }, value: form.phs, type: "number", placeholder: '0.0' }),
                            React.createElement(AonInput, { "aria-label": "Outlined", disabled: apiLoading, onTextChange: function (event) { return saveForm("capacity", event.target.value); }, value: form.capacity, type: "number", placeholder: '0.0' })))),
                React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                    React.createElement(UuiFlexlayout, { direction: 'column' },
                        React.createElement("div", { style: { paddingBottom: "5px" } }, "A M Best"),
                        React.createElement(UuiFlexlayout, { direction: 'row', gap: 'xs' },
                            React.createElement(AonSelect, { layout: "TOP", style: { width: 165 }, defaultValue: 'From', selectedValue: form.amBest_a, handelChecked: function (event) { saveForm("amBest_a", event.target.selectedValue); }, options: __spreadArray([], allOptions.amBest ? allOptions.amBest.map(function (item) {
                                    return ({ label: item.rating, value: item.amBestRatingInfoId.toString() });
                                }) : [], true) }),
                            React.createElement(AonSelect, { layout: "TOP", style: { width: 165 }, defaultValue: 'To', selectedValue: form.amBest_b, handelChecked: function (event) { saveForm("amBest_b", event.target.selectedValue); }, options: __spreadArray([], allOptions.amBest ? allOptions.amBest.map(function (item) {
                                    return ({ label: item.rating, value: item.amBestRatingInfoId.toString() });
                                }) : [], true) }))),
                    React.createElement(UuiFlexlayout, { direction: 'column' },
                        React.createElement("div", { style: { paddingBottom: "5px" } }, "S & P"),
                        React.createElement(UuiFlexlayout, { direction: 'row', gap: 'xs' },
                            React.createElement(AonSelect, { layout: "TOP", style: { width: 165 }, defaultValue: 'From', selectedValue: form.sAndp_a, handelChecked: function (event) { saveForm("sAndp_a", event.target.selectedValue); }, options: __spreadArray([], allOptions.sp ? allOptions.sp.map(function (item) {
                                    return ({ label: item.rating, value: item.sandPRatingInfoId.toString() });
                                }) : [], true) }),
                            React.createElement(AonSelect, { layout: "TOP", style: { width: 165 }, defaultValue: 'To', selectedValue: form.sAndp_b, handelChecked: function (event) { saveForm("sAndp_b", event.target.selectedValue); }, options: __spreadArray([], allOptions.sp ? allOptions.sp.map(function (item) {
                                    return ({ label: item.rating, value: item.sandPRatingInfoId.toString() });
                                }) : [], true) })))),
                React.createElement("div", { style: { display: "flex", marginTop: "35px" } },
                    React.createElement(AonButton, { disabled: apiLoading, style: { marginRight: "10px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                            onClickSubmit();
                        } }, "Search"),
                    React.createElement(AonButton, { style: { marginRight: "10px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: function () {
                            onResetForm();
                        } }, "Reset"))),
            validationError.length > 0 && (React.createElement(AonDialog, { extraClass: "aon-dialog-validation-error", dismissOnEsc: false, dismissOnOverlay: false, opened: true, enableBackgroundScroll: false, header: React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "default", userSelect: "none" } },
                    React.createElement("span", { style: { color: "#dc3545", fontWeight: "bold", fontSize: "16px", fontFamily: "inherit" } }, "Validation Error"),
                    React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: function () { return setValidationError([]); }, icon: faClose, style: { cursor: "pointer", marginLeft: "24px" } })), body: React.createElement("div", { style: { padding: "0" } }, validationError.map(function (err, idx) { return (React.createElement("p", { key: idx, style: { color: "#dc3545", margin: "0 0 4px 0", fontSize: "14px", fontFamily: "inherit", cursor: "default", userSelect: "none" } }, err)); })), footer: React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement("button", { onClick: function () { return setValidationError([]); }, style: {
                            backgroundColor: "#007b8f",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            padding: "8px 20px",
                            fontSize: "14px",
                            fontFamily: "inherit",
                            cursor: "pointer",
                            textDecoration: "none",
                            userSelect: "none",
                        } }, "Ok")) }))));
    };
    var extraClass = "aon-dialog-advsearch";
    if (props.extraClasses) {
        extraClass = extraClass + " " + props.extraClasses;
    }
    return React.createElement(AonDialog, { extraClass: extraClass, dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDailog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(DailogBody, null) });
});
